/*
 * @Descripttion: （建筑物分类）楼宇类别 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-03-18
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-03-18 21:10:12
 */

import http from '@/utils/kq/http';

const veSbzcJzwBuildcateApi = {
  //添加接口
  add(data) {
    return http.post(http.service.sbzc + 'veSbzcJzwBuildcate/add', data);
  },
  //删除接口
  delete(ids) {
    return http.delete(http.service.sbzc + 'veSbzcJzwBuildcate/deleteBatch?ids=' + ids);
  },
  //修改接口
  update(data) {
    return http.put(http.service.sbzc + 'veSbzcJzwBuildcate/edit', data);
  },
  //分页查询接口
  page(pageData) {
    return http.post(http.service.sbzc + 'veSbzcJzwBuildcate/page', pageData);
  },
  //分页查询接口
  all(pageData) {
    return http.post(http.service.sbzc + 'veSbzcJzwBuildcate/all', pageData);
  },
  //查询单个数据接口
  get(id) {
    return http.get(http.service.sbzc + 'veSbzcJzwBuildcate/queryById', { id: id });
  },
  //更新状态
  updateStatus(data) {
    return http.post(http.service.sbzc + 'veSbzcJzwBuildcate/updateStatus', data);
  }
};
export default veSbzcJzwBuildcateApi;
